var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"500px","height":"400px"}},[_c('live-player',{ref:"p1",attrs:{"bind-callback":_vm.handleBind,"pause-callback":_vm.handlePause,"play-callback":_vm.handlePlay,"distroy-callback":_vm.handleDistroy}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }